import { render, staticRenderFns } from "./AddOffsiteService.vue?vue&type=template&id=c9e6f184&scoped=true&"
import script from "./AddOffsiteService.vue?vue&type=script&lang=js&"
export * from "./AddOffsiteService.vue?vue&type=script&lang=js&"
import style0 from "./AddOffsiteService.vue?vue&type=style&index=0&id=c9e6f184&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e6f184",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDatePicker,VForm,VRow})
